export default {
    state: {
        category_id: null,
        errors: {},
        parent_categories: [],
        categories: [],
        form: {
            code: '',
            name: '',
            description: '',
            parent_category_id: '',
        },

        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'description', label: 'Description', tdClass: 'text-muted'},
                {key: 'image', label: 'Image', tdClass: 'text-muted'},
                {key: 'parent_category', label: 'Parent Category', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },

        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
    },

    getters: {
        getProductCategoryTableFields: state => state.table.fields,

        getProductCategoryMeta: state => state.meta,

        getSelectParentCategories: state => state.parent_categories,

        getProductCategoryForm: state => state.form,

        getProductCategoryErrors: state => state.errors,
    },

    mutations: {
        resetProductCategoriesMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setProductCategories: (state, payload) => {
            state.categories = payload;
        },

        setProductCategoriesMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setProductCategoryForm: state => {
            state.form = {
                code: '',
                name: '',
                description: '',
                parent_category_id: '',
            };

            state.errors = {};
        },

        setProductCategoryErrors: (state, payload) => {
            state.errors = payload;
        },

    },

    actions: {
        fetchProductCategories: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const categories = {
                "data": [
                    {
                        "unit_id": 1,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile",
                                "description": "Test Here 1",
                                "image": "image1.jpg",
                                "parent_category": "Electronics",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/1"}
                    },
                    {
                        "unit_id": 2,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Mobile",
                                "description": "Test Here 2",
                                "image": "image2.jpg",
                                "parent_category": "Food",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/2"}
                    },
                    {
                        "unit_id": 3,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Mobile",
                                "description": "Test Here 3",
                                "image": "image3.jpg",
                                "parent_category": "Grocerries",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/3"}
                    }
                ],
                "links": {
                    "self": "\/units",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/units",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setProductCategories', categories);

                commit('setProductCategoriesMeta', categories.meta);

                resolve(categories);
            });
        },

        fetchEditProductCategory: ({state, commit}, ctegory_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + ctegory_id + '/edit')
                    .then(response => {
                        state.category_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitProductCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductCategoryErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateProductCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.category_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductCategoryErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.category_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

    }
}
